<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Category show</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Category show</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="card">
        <div class="overlay" v-if="is_loading">
          <i class="fas fa-2x fa-sync-alt fa-spin"></i>
        </div>
        <div class="card-header">
          <h3 class="card-title">Detail</h3>
          <div class="card-tools">
            <router-link class="btn btn-info" :to="{ name: 'Categories' }">
              <i class="fas fa-list"></i> List
            </router-link>
          </div>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-striped">
            <tbody>
              <tr>
                <td><b>Name</b></td>
                <td>{{ item.name }}</td>
              </tr>
            </tbody>

            <tbody>
              <tr>
                <td><b>Slug</b></td>
                <td>{{ item.slug }}</td>
              </tr>
              <tr>
                <td><b>Service Logo</b></td>
                <td>
                  <img
                    v-if="item.thumbnail"
                    v-bind:src="thumbnail"
                    alt="thumbnail"
                    class="img-thumbnail"
                    width="300"
                    height="300"
                  />
                </td>
              </tr>
              <tr>
                <td><b>Created At</b></td>
                <td>
                  {{ !_.isEmpty(item.created_at) ? item.created_at : "" }}
                </td>
              </tr>
              <tr>
                <td><b>Updated At</b></td>
                <td>
                  {{ !_.isEmpty(item.updated_at) ? item.updated_at : "" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer"></div>
      </div>
    </section>
  </div>
</template>

<script>
import { CategoryAPI } from "@/services/api";

export default {
  name: "CategoryShow",
  metaInfo: {
    title: "Category Detail | Dotlines",
  },
  data: () => ({
    item: {},
    is_loading: false,
    thumbnail: "",
  }),
  mounted: function () {
    this.itemShow(this.$route.params.id);
  },
  methods: {
    itemShow(id) {
      CategoryAPI.show(id).then((result) => {
        this.item = result;
        this.asset_get_url = this.API_ASSET_UPLOAD_URL;
        this.thumbnail = this.asset_get_url + "/" + this.item.thumbnail;
      });
    },
  },
};
</script>
